export const SERVERS_NAMESPACE = '@SERVER_MANAGEMENT';
